import { useEffect } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';

import { MenuProvider } from '@/components/Menu/context/menuContext';
import { useNav } from '@/features/layout/useNav';
import { updateQuery } from '@/hooks/useQuery';
import useQueryParams from '@/hooks/useQueryParams';
import { useFetchOperatingHoursList } from '@/services';

/**
 *
 * 업무관리 > 스케줄 화면 진입시 호출되는 컴포넌트
 *
 * @role
 * - TO 리스트의 첫번째 TO id로 operatingId query 셋팅
 * - 고객사명, 지점명으로 breadscrumb 셋팅
 *
 * @reference @/navigation/routes 참조
 */

const ScheduleRoute = () => {
  const { clientId, venueId } = useParams();

  const { pathname } = useLocation();
  const { onSetBreadscrumb } = useNav();

  const { data: operatingHoursData } = useFetchOperatingHoursList({
    venueId: Number(venueId),
  });

  const { operatingId } = useQueryParams(['search', 'operatingId']);

  useEffect(() => {
    if (!operatingHoursData) {
      return;
    }
    const operatingHours = operatingHoursData.operatingHours;

    /**
     * 업무관리 화면에서 TO 상세화면으로 전환시, TO 리스트의 첫번째 TO id를 query에 세팅해준다.
     * @example TO 스케줄 컴포넌트에서 operatingId로 TO 상세 데이터를 가져오기
     */
    if (!operatingId && operatingHours && operatingHours?.length > 0) {
      updateQuery({ operatingId: operatingHours?.[0].id }, true);
    }
  }, [operatingHoursData, operatingId]);

  useEffect(() => {
    onSetBreadscrumb([
      {
        label: '업무관리',
        path: `/task/client/${clientId}/venue/${venueId}`,
      },
      ...(operatingHoursData
        ? [
            {
              label:
                operatingHoursData?.client?.companyName +
                ' ' +
                operatingHoursData?.venue?.name,
              path: '',
            },
          ]
        : []),
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, operatingHoursData]);

  return (
    <MenuProvider>
      <Outlet />
    </MenuProvider>
  );
};
export default ScheduleRoute;
